module.exports = __webpack_public_path__ + "static/media/18.d0ff6577.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/18.jpg
// module id = 708
// module chunks = 0